<template>
  <div>
    <div
      class="level first-result"
    >
      <div class="level-left">
        <div class="level-item">
          <div>
            <p class="is-size-2 has-text-weight-bold">
              <font-awesome-icon
                icon="arrow-circle-right"
                class="domain-icon"
              />
              {{ $t('domains.unavailable', { name: searchTerm}) }}
            </p>
            <p class="is-medium">
              {{ $t('domains.try_again') }}
            </p>
          </div>
        </div>
      </div>
      <div class="level-right">
        <a
          v-show="false"
          class="button is-uppercase is-primary is-broad is-large level-item"
          @click="$emit('transferDomain', searchTerm)"
        >
          {{ $t('domains.transfer_button') }}
        </a>
      </div>
    </div>
    <!-- Offer alternative domains, .org, .net etc.... -->
    <div class="columns mt-10 has-text-centered-mobile">
      <div class="column">
        <p class="is-size-3 has-text-dark has-text-weight-bold">
          {{ $t('domains.alternative') }}
        </p>
      </div>
    </div>
    <div
      v-for="domain in domainsFound"
      :key="domain.name"
      :class="rowClass(domain.term)"
    >
      <div class="level-left">
        <p class="is-size-2 has-text-weight-bold level-item">
          {{ domain.name }}
        </p>
      </div>
      <div
        v-show="isServiceAllowed(domain.term)"
        class="level-right"
      >
        <a
          class="button is-primary is-broad is-uppercase is-large level-item"
          @click="$emit('domainSelected', domain.name)"
        >
          {{ $t('domains.select_button') }}
        </a>
      </div>
      <div
        v-show="!isServiceAllowed(domain.term)"
        class="level-right"
      >
        <a
          class="button is-broad is-uppercase is-large level-item disabled is-static"
        >
          {{ $t('domains.not_available') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

// #7a7a7a

export default {

  name: 'DomainSearchNotFound',
  props: {
    searchTerm: {
      type: String,
      default: ''
    },
    domainsFound: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapGetters('domainService', ['domainData'])
  },
  methods: {
    isServiceAllowed (terms) {
      if (terms.includes(this.domainData.term)) {
        return true
      }
      return false
    },
    rowClass (terms) {
      if (terms.includes(this.domainData.term)) {
        return 'level domain-result has-text-centered-mobile'
      }
      return 'level domain-result-not-elegible has-text-centered-mobile'
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/mystyles.scss';

.first-result {
  background: var(--primary-color);
  padding: 30px 30px 40px;
  margin-top: 15px;
}
.is-static {
  border: 2px solid #dbdbdb;
}
.domain-result {
  padding: 10px;
  border: 1px solid $light-grey;
  color: var(--primary-color);
}
.domain-result-not-elegible {
  padding: 10px;
  border: 1px solid $light-grey;
  color: $medium-grey;
}
.mt-10 {
  margin-top: 10px;
}
.domain-icon {
  margin-right: 5px;
  font-size: 25px;
}

</style>
